import React from 'react';
import ReactDOM from 'react-dom/client';
import "./services/toast_patch";
import App from './apps/app/components/App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './index.css';
import { AuthProvider } from "./services/authContext";

import { useEffect, useState } from "react";

function ScreenBlocker() {
  const check = () => window.innerWidth >= 1900 && window.innerWidth <= 1950;

  const [isAllowed, setIsAllowed] = useState(check());

  useEffect(() => {
    const handleResize = () => setIsAllowed(check());

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isAllowed) return null;

    return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "white",
      zIndex: 9999,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column"
    }}>
      <img src="/build.png" alt="" style={{ width: 128, height: 128}} />
      <h2>Modalità responsive in arrivo</h2>
      <p>Risoluzione test consigliata 1920 * 1080</p>
    </div>
  );
}

export default ScreenBlocker;




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
